LabelCeListController.$inject = ['$stateParams', 'notification'];

export default function LabelCeListController($stateParams, notification) {}
